import { DocumentFileSave } from './request'
import {
  Document,
  DocumentFile,
  isPreviousDocument,
  isSupportingDocument,
  isTransportDocument,
  PreviousDocument,
  SupportingDocument,
  TransportDocument,
} from './types'

export function toTransportDocuments(documents: Document[]): TransportDocument[] {
  return documents.filter(isTransportDocument)
}

export function toPreviousDocuments(documents: Document[]): PreviousDocument[] {
  return documents.filter(isPreviousDocument)
}

export function toSupportingDocuments(documents: Document[]): SupportingDocument[] {
  return documents.filter(isSupportingDocument)
}

export type PersistedDocumentFileSave = DocumentFileSave & {
  id: number
  documentId: number
  uuid: string
}

export function isPersistedDocumentFileSave(file: DocumentFileSave): file is PersistedDocumentFileSave {
  return file.id != null && file.documentId != null && file.uuid != null
}

export function fromDocumentFileSave(file: PersistedDocumentFileSave): DocumentFile {
  return {
    id: file.id,
    fileName: file.fileName,
    documentId: file.documentId,
    mimeType: file.mimeType,
    sequenceNumber: file.sequenceNumber,
    deleted: false,
    uuid: file.uuid,
    file: null,
    fileBlob: null,
    url: null,
  }
}

export function fromDocumentFileSaves(files: DocumentFileSave[]): DocumentFile[] {
  return files
    .filter(isPersistedDocumentFileSave)
    .map(fromDocumentFileSave)
}
